import ApplicationController from './application_controller'

export default class extends ApplicationController {

  toggle (event) {
    if (event) event.preventDefault()
    this.element.classList.toggle('is-active')
  }
}
